import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { useCompare } from "@/hooks/use-compare";
import { X, GitCompare, Truck } from "lucide-react";

const CompareBar = () => {
  const { compareList, toggleCompare, clearCompare } = useCompare();

  const { data: companies } = useQuery({
    queryKey: ["compare-companies", compareList],
    queryFn: async () => {
      if (compareList.length === 0) return [];
      const { data } = await supabase
        .from("companies")
        .select("id, company_name")
        .in("id", compareList);
      return data || [];
    },
    enabled: compareList.length > 0,
  });

  if (compareList.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border shadow-lg animate-fade-in">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2 flex-1 overflow-x-auto">
            <GitCompare className="w-5 h-5 text-primary flex-shrink-0" />
            <span className="text-sm font-medium text-muted-foreground flex-shrink-0">
              Vergelijken ({compareList.length}/4):
            </span>
            <div className="flex items-center gap-2">
              {companies?.map((company) => (
                <div
                  key={company.id}
                  className="flex items-center gap-2 bg-muted rounded-full pl-3 pr-1 py-1"
                >
                  <Truck className="w-4 h-4 text-primary" />
                  <span className="text-sm font-medium truncate max-w-[120px]">
                    {company.company_name}
                  </span>
                  <button
                    onClick={() => toggleCompare(company.id)}
                    className="p-1 rounded-full hover:bg-background transition-colors"
                    aria-label={`Verwijder ${company.company_name}`}
                  >
                    <X className="w-4 h-4 text-muted-foreground" />
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <Button
              variant="ghost"
              size="sm"
              onClick={clearCompare}
              className="text-muted-foreground"
            >
              Wissen
            </Button>
            <Link to="/vergelijken">
              <Button size="sm" disabled={compareList.length < 2}>
                <GitCompare className="w-4 h-4 mr-2" />
                Vergelijken
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompareBar;
